import React, { useCallback, useContext, useEffect, useState } from "react";
import { AppContext } from "../../appContext";
import { fileUploadApi, getUserApi, UpdateUserDetails } from "../../apis";
import { useFormik } from "formik";
import { editUserProfile } from "../../components/Validation";
import toast from "react-hot-toast";
import { useDropzone } from 'react-dropzone';
import { InputErrorMessage } from "../../components/errorMessages";
import { EditProfileLoader, Loader } from "../../components/common/loader";
import SimpleButton from "../../components/common/buttons/SimpleButton/SimpleButton";
import { FaUser } from "react-icons/fa";
import { MdPhotoCamera } from "react-icons/md";
import ProfileTopNavigation from "../../Pages/ProfileLayout/ProfileTopNavigation";

export default function PersonalDetailsSection({ }) {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [profileData, setprofileData] = useState('');
    const { getUserDetails } = useContext(AppContext);
    const [loading,setloading]=useState(false);

    const fetchData = async () => {
        try {
            const res = await getUserApi();
            if (res.status === 200) {
                setprofileData(res?.data?.Profile);
            }
        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    const formik = useFormik({
        initialValues: {
            userEmail: profileData?.email || '',
            contactNumber: profileData?.DoctorProfile?.phoneNo || '',
            profile: profileData?.DoctorProfile?.coverPic || '',
            specialization: profileData?.DoctorProfile?.specialization?.name || '',
        },
        enableReinitialize: true,
        validationSchema: editUserProfile,
        onSubmit: async (values) => {
            console.log(values);
            const { userEmail, contactNumber, profile } = values;

            const payloadFormate = {
                profileId: profileData.DoctorProfile?._id,
                email: userEmail,
                phoneNo: contactNumber,
                coverPic: profile,
            };
            console.log(payloadFormate);
            setloading(true);
            try {
                const res = await UpdateUserDetails(payloadFormate);
                if (res.status === 200) {
                    toast.success('Profile updated successfully');
                    getUserDetails();
                }
            } catch (error) {
                console.log(error.response.data.error);
                const message = error.response.data.error || error.response.statusText;
                toast.error(message, { id: 'error' });
            }
            finally{
                setloading(false);
            }
        },
    });
    const handleChange = (e) => {
        e.preventDefault();
        formik.handleChange(e);
    };
    const onDropProfile = useCallback(async (acceptedFiles) => {
        if (acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            await profilefileUpload(file);
        }
    }, []);
    const profileonUploadProgress = (progressEvent, file) => {
        console.log(progressEvent);
    };
    const [isprofile, setisprofile] = useState(false);
    const profilefileUpload = async (file) => {
        try {
            setisprofile(true);
            const formData = new FormData();
            formData.append('file', file);
            // Make the file upload request
            const uploadResponse = await fileUploadApi(formData, (progressEvent) =>
                profileonUploadProgress(progressEvent, file)
            );

            if (uploadResponse.status === 200 || uploadResponse.status === 201) {
                // Here we update only the profile field
                setisprofile(false);
                formik.setFieldValue('profile', uploadResponse.data.filePath);
            } else {
                setisprofile(false);
                toast.error('image upload failed', { is: 'err' });
            }
        } catch (error) {
            setisprofile(false);
            console.error('An error occurred:', error);
            toast.error('image upload failed', { is: 'err' });
        } finally {
            setisprofile(false);
        }
    };

    const {
        getRootProps: getRootPropsProfile,
        getInputProps: getInputPropsProfile,
        isDragActive: isDragActiveProfile,
    } = useDropzone({
        onDrop: onDropProfile,
    });


    return (
        <section className="pt-[14%] pb-10 max-w-md md:max-w-[80vw] md:pt-[6%] md:ml-[auto] md:mr-[auto] lg:ml-1  px-6 bg-white lg:pt-[0px] lg:pb-[0px] lg:my-7 lg:px-2 marginx_auto custom_x_margin custom_pt_md">

            <div className="">

                {/* profile pic background img */}
                <div className="h-40 relative rounded-xl" style={{ backgroundColor: !isprofile ? 'none' : 'var(--accent)' }}>
                    {formik.values.profile ? (
                        <img
                            src={`${process.env.REACT_APP_API_URL}/${formik.values.profile}`}
                            alt="Profile"
                            className="h-full object-cover rounded-xl w-full blur-[1px]"
                            style={{ display: isprofile ? 'none' : 'block' }}
                        />
                    ) : (
                        <img className="h-full object-cover rounded-xl w-full" src="/static/media/Graphic Side.beb1d79d8c7bca18e945.jpg" />
                    )}
                </div>

                {/* Profile pic */}
                <div className="profileImage flex flex-col items-center justify-center relative -mt-8 lg:items-center lg:pe-0">
                    <div
                        className="size-20 rounded-full relative flex items-center justify-center"
                        {...getRootPropsProfile()}
                    >
                        {isprofile && <EditProfileLoader />}
                        {formik.values.profile ? (
                            <img
                                src={`${process.env.REACT_APP_API_URL}/${formik.values.profile}`}
                                alt="Profile"
                                className="w-full h-full object-cover rounded-full"
                                style={{ display: isprofile ? 'none' : 'block' }}
                            />
                        ) : (
                            <div className="w-full h-full bg-gray-200 rounded-full flex items-center justify-center">
                                <FaUser className="text-gray-400 text-base" size={30} />
                            </div>
                        )}
                        <div className="bg-black/25 p-1.5 rounded-full absolute bottom-0 -right-2">
                            <MdPhotoCamera className="text-white text-base" />
                        </div>
                    </div>
                    <input {...getInputPropsProfile()} />
                    <p className="my-1 py-1 smallText  text-navLink">
                        {!formik.values.profile && 'Upload your profile image '}
                    </p>
                </div>

            </div>
            <form className="mt-11 space-y-4">
                <h2 className="baseText !font-medium">Personal information</h2>
                <div className="userEmail">
                    <p className="baseText text-coalBlack mb-2 capitalize">Email</p>
                    <div
                        className={
                            Boolean(formik.touched.userEmail) &&
                                Boolean(formik.errors.userEmail)
                                ? 'form-control overflow-hidden line-clamp-1 border-danger transparent-input-border flex items-center'
                                : 'form-control overflow-hidden line-clamp-1 transparent-input-border flex items-center'
                        }
                    >
                        <div style={{ width: '95%' }}>
                            <input
                                type="text"
                                name="userEmail"
                                style={{ background: 'transparent', width: '100%' }}
                                id="userEmail"
                                placeholder="Enter name :"
                                value={formik.values.userEmail}
                                title={formik.values.userEmail}
                                onChange={handleChange}
                                disabled
                            />
                        </div>
                    </div>
                    {
                        (formik.touched.userEmail && formik.errors.userEmail) &&
                        <InputErrorMessage
                            error={formik.touched.userEmail && formik.errors.userEmail}
                        />
                    }

                </div>

                <div className="contactNumber">
                    <p className="baseText text-coalBlack mb-2 capitalize">
                        Mobile Number
                    </p>
                    <div className="relative">
                        <input
                            type="tel"
                            name="contactNumber"
                            className={
                                Boolean(formik.touched.contactNumber) &&
                                    Boolean(formik.errors.contactNumber)
                                    ? 'form-control border-danger transparent-input-border'
                                    : 'form-control transparent-input-border'
                            }
                            id="contactNumber"
                            placeholder="Enter mobile no :"
                            value={formik.values.contactNumber}
                            onChange={handleChange}
                            maxLength={10} // Ensures max 10 characters
                            pattern="\d{10}" // Ensures exactly 10 digits in a form submission
                            onInput={(e) => {
                                e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10); // Allows only digits
                            }}
                        />
                    </div>
                    {
                        (formik.touched.contactNumber && formik.errors.contactNumber) &&
                        <InputErrorMessage
                            error={formik.touched.contactNumber && formik.errors.contactNumber}
                        />
                    }

                </div>

                <div className="specialization">
                    <p className="baseText text-coalBlack mb-2 capitalize">
                        Specialization
                    </p>
                    <div className="relative">
                        <input
                            type="text"
                            name="specialization"
                            className='form-control transparent-input-border'
                            id="specialization"
                            placeholder="Enter specialization"
                            value={formik.values.specialization}
                            disabled
                        />
                    </div>
                    

                </div>
                
                <SimpleButton
                    customClass={'bg-accent text-white rounded-lg w-full mt-7'}
                    buttonType={'primary'}
                    title={loading ? <EditProfileLoader /> : 'Update'}
                    onClickEvent={formik.handleSubmit}
                />
            </form>
        </section>
    )
}